import React from 'react';
import { Box, Body, BoxProps } from '@hover/blueprint';

interface Props extends BoxProps {
  title: string;
  body: string;
}

const MaterialDetails: React.FC<Props> = ({ title, body, ...rest }) => (
  <Box flexDir="column" alignItems="center" {...rest} maxW="2xl">
    <Body as="h3" textAlign="center" isBold mb={400}>
      {title}
    </Body>
    <Body textAlign="center">{body}</Body>
  </Box>
);

export default MaterialDetails;
